import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { ConnectionKnovioFormPresentation } from './connection-knovio-form.presentation';
import { ConnectionKnovioFormVM } from './connection-knovio-form.viewmodel';

export type ConnectionsTemplateFormProps = {
    connection: TConnection;
    addConnection: (connection: TConnection) => void;
    editConnection: (connection: TConnection) => void;
};

export const ConnectionKnovioForm = withViewModel(ConnectionKnovioFormPresentation, (props: ConnectionsTemplateFormProps) => {
    return new ConnectionKnovioFormVM(props.connection, props.addConnection, props.editConnection);
});
